import { render, staticRenderFns } from "./ErrorTips.vue?vue&type=template&id=59e173b3&scoped=true&"
import script from "./ErrorTips.vue?vue&type=script&lang=js&"
export * from "./ErrorTips.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTips.vue?vue&type=style&index=0&id=59e173b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e173b3",
  null
  
)

export default component.exports